export const nameExtractor = (url) => {
  let test = url.split("?");
  const str = test[0].split("/").pop();
  return str
};
